import {
  watch
} from "./chunk.H7XADNZ7.js";
import {
  e,
  n
} from "./chunk.5E26GMTR.js";
import {
  component_styles_default,
  r,
  s4
} from "./chunk.3PRAXUFA.js";
import {
  __decorateClass
} from "./chunk.7RPYXGIF.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.6Q6RSBMS.js
var divider_styles_default = r` ${component_styles_default} :host { --color: var(--sl-panel-border-color); --width: var(--sl-panel-border-width); --spacing: var(--sl-spacing-medium); } :host(:not([vertical])) { display: block; border-top: solid var(--width) var(--color); margin: var(--spacing) 0; } :host([vertical]) { display: inline-block; height: 100%; border-left: solid var(--width) var(--color); margin: 0 var(--spacing); } `;

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.FITQ3IRS.js
var SlDivider = class extends s4 {
  constructor() {
    super(...arguments);
    this.vertical = false;
  }
  firstUpdated() {
    this.setAttribute("role", "separator");
  }
  handleVerticalChange() {
    this.setAttribute("aria-orientation", this.vertical ? "vertical" : "horizontal");
  }
};
SlDivider.styles = divider_styles_default;
__decorateClass([
  e({ type: Boolean, reflect: true })
], SlDivider.prototype, "vertical", 2);
__decorateClass([
  watch("vertical")
], SlDivider.prototype, "handleVerticalChange", 1);
SlDivider = __decorateClass([
  n("sl-divider")
], SlDivider);

export {
  SlDivider
};
